var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBatteryDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9 8.98c-.39 0-.7.31-.7.7v4.65c0 .39.31.7.7.7.2 0 .37-.01.54-.02C22 14.83 22 13.73 22 12.93v-1.86c0-.8 0-1.9-1.58-2.07-.14-.01-.32-.02-.52-.02zM18.28 13.86c0 2.95-2.4 5.35-5.35 5.35H9.26c-.79 0-1.27-.87-.85-1.53L15.67 6.2c.36-.57 1.17-.62 1.62-.11.72.83.99 2.12.99 4.05v3.72zM15.37 2.1l-1.71 2.71c-.23-.01-.47-.02-.73-.02H7.35C3.25 4.79 2 6.04 2 10.14v3.72c0 3.05.7 4.51 2.74 5.06L3.37 21.1c-.22.35-.12.81.23 1.03.12.08.26.12.4.12.25 0 .49-.12.63-.35l12-19c.23-.35.12-.81-.23-1.03a.745.745 0 0 0-1.03.23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBatteryDisable);
export default __webpack_public_path__ + "static/media/vuesax-bold-battery-disable.c569b1caa4ecdc51ec38ee7f94350960.svg";
export { ForwardRef as ReactComponent };